import { call, put, flush, delay, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";

import { INIT_REQUEST_UPBIT, INIT_SUCCESS_UPBIT, RECEIVE } from '../modules/upbit';

import { upbitTicker, UpbitTickerPacket } from '../../utils/parser';
import { createSocket, connectSocekt } from '../../utils/common';
import { arrToObj, latestTicker } from '../../utils/array';

import { CoinCommon } from '../../types';

function* init({ payload }: any): SagaIterator {
  try {
    const codes: string[] = payload.map((item: {name: string}) => item.name)
    if (!codes.length) return

    yield put({
      type: INIT_SUCCESS_UPBIT,
      payload: {
        data: codes,
        m: arrToObj(codes)
      }
    })

    const client: WebSocket = yield call(createSocket, "wss://api.upbit.com/websocket/v1", "arraybuffer");
    const clientChannel = yield call( connectSocekt, 
      client, 
      JSON.stringify([
        { ticket: "ticket" },
        { type: 'ticker', codes },
      ]),
      (evt: { data: any }) => {
        const enc = new TextDecoder("utf-8");
        const arr = new Uint8Array(evt.data);
        const data = JSON.parse(enc.decode(arr));

        return [
          true,
          data
        ]
      },
    )
    
    while (true) {
      const datas: UpbitTickerPacket[] = yield flush(clientChannel) ; // 버퍼 데이터 가져오기

      if (datas.length) {
        const sortedData: CoinCommon[] = latestTicker<UpbitTickerPacket>(datas, upbitTicker);
        
        yield put({
          type: RECEIVE,
          payload: {
            data: sortedData,
          }
        })
      }
      
      yield delay(350); 
    }
  } catch (err) {
    console.log('[SAGA] getUserInfo API error');
    console.log(err)
  }

}

function* upbitSaga() {
  yield takeEvery(INIT_REQUEST_UPBIT, init);
}

export default upbitSaga;